let ShipmentsById = new Map();

ShipmentsById.set(1, {
    referenceNumber: "502230011",
    CSR: "CSR-1",
    status: "Pending",
    salesOrder: "SalesOrder-1",
    PO: "PO-1",
    bookingNumber: "BookingNumber-1",
    deliveryNumber: "DeliveryNumber-1",
    division: "Division-1",
    customer: "Customer One",
    shipper: "Shipper for Customer 1",
    incoTerms: "IncoTerms-1",
    placeOfReceipt: "SHANGHAI, CHINA",
    portOfLoading: "SHANGHAI, CHINA",
    portOfDischarge: "RALEIGH, NC",
    placeOfDelivery: "RALEIGH, NC",
    carrierName: "Generic Logistics 1",
    vesselVoyage: "VesselVoyage-1",
})

ShipmentsById.set(2, {
    referenceNumber: "502230012",
    CSR: "CSR-2",
    status: "Pending",
    salesOrder: "SalesOrder-2",
    PO: "PO-2",
    bookingNumber: "BookingNumber-2",
    deliveryNumber: "DeliveryNumber-2",
    division: "Division-2",
    customer: "Customer One",
    shipper: "Shipper for Customer 2",
    incoTerms: "IncoTerms-2",
    placeOfReceipt: "SHANGHAI, CHINA",
    portOfLoading: "SHANGHAI, CHINA",
    portOfDischarge: "RALEIGH, NC",
    placeOfDelivery: "RALEIGH, NC",
    carrierName: "Generic Logistics 2",
    vesselVoyage: "VesselVoyage-2",
})

ShipmentsById.set(3, {
    referenceNumber: "502230013",
    CSR: "CSR-3",
    status: "Pending",
    salesOrder: "SalesOrder-3",
    PO: "PO-3",
    bookingNumber: "BookingNumber-3",
    deliveryNumber: "DeliveryNumber-3",
    division: "Division-3",
    customer: "Customer One",
    shipper: "Shipper for Customer 3",
    incoTerms: "IncoTerms-3",
    placeOfReceipt: "SHANGHAI, CHINA",
    portOfLoading: "SHANGHAI, CHINA",
    portOfDischarge: "RALEIGH, NC",
    placeOfDelivery: "RALEIGH, NC",
    carrierName: "Generic Logistics 3",
    vesselVoyage: "VesselVoyage-3",
})

export default ShipmentsById;